import styled from "styled-components";

export const Container = styled.div``;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
`;
